import initCustomer from './event-on-customer';
import initTag from './event-on-tag';
import initPersonal from './event-on-personal';
import conversation from './event-on-conversation';
import initAgent from './event-on-agent';
import initPayment from './event-on-payment';
import initLogin from './event-on-login';

const eventOn = (emitter, socket) => {
  // emitter.on('closeSocket', () => {
  //   socket.close();
  // });
  conversation(emitter, socket);
  initCustomer(emitter, socket);
  initTag(emitter, socket);
  initPersonal(emitter, socket);
  initAgent(emitter, socket);
  initPayment(emitter, socket);
  initLogin(emitter, socket);
};

export default eventOn;
